import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, DownloadSimple, ArrowsClockwise } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';

/**
 * Header for the Denials & Rejections dashboard — back button, title,
 * Refresh + Export CSV CTAs.
 */
const DenialsHeader = ({ onRefresh, onExport, exporting, total }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/claims')}
          className="text-slate-500 hover:text-slate-900"
          data-testid="back-to-claims-btn"
        >
          <ArrowLeft size={16} className="mr-1" />
          Claims
        </Button>
        <div className="border-l border-slate-200 pl-3">
          <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>
            Denials &amp; Rejections
          </h1>
          <p className="text-slate-500 mt-1 text-sm">
            {total} denial{total === 1 ? '' : 's'} matching current filters · prioritise rework by
            frequency &amp; dollar impact
          </p>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          onClick={onRefresh}
          className="border-slate-200"
          data-testid="denials-refresh-btn"
        >
          <ArrowsClockwise size={16} className="mr-2" />
          Refresh
        </Button>
        <Button
          onClick={onExport}
          disabled={exporting || total === 0}
          className="bg-indigo-900 hover:bg-indigo-800 text-white"
          data-testid="denials-export-btn"
        >
          <DownloadSimple size={16} className="mr-2" />
          {exporting ? 'Exporting…' : 'Export CSV'}
        </Button>
      </div>
    </div>
  );
};

export default DenialsHeader;
